import { createAction } from "redux-actions";
import { takeLatest, put, select, call, all } from "redux-saga/effects";
import axios from "axios";
import moment from "moment";
import { queryParams } from "../../../../utils/queryParams";
import { API_DATE_FORMAT } from "../../../../app_constants";

export const SET_LOADING = "./FirstVisit/SET_LOADING";
export const FETCH_CHART_SUCCESS = "./FirstVisit/FETCH_CHART_SUCCESS";
export const FETCH_CURRENT_USER = "./FirstVisit/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS = "./FirstVisit/FETCH_CURRENT_USER_SUCCESS";
export const RESET_FILTER_SELECTED = "./FirstVisit/RESET_FILTER_SELECTED";
export const SET_DATES = "./FirstVisit/SET_DATES";
export const SET_FILTERS_DIRTY = "./FirstVisit/SET_FILTERS_DIRTY";
export const SET_UPDATES_LOADING = "./FirstVisit/SET_UPDATES_LOADING";
export const UPDATE_DATES = "./FirstVisit/UPDATE_DATES";
export const UPDATE_CHART = "./FirstVisit/UPDATE_CHART";
export const RESET_FILTER = "./FirstVisit/RESET_FILTERS";
export const UPDATE_PERIOD_DAYS = "./FirstVisit/UPDATE_PERIOD_DAYS";
export const UPDATE_CUSTOM_RANGE = "./FirstVisit/UPDATE_CUSTOM_RANGE";
export const UPDATE_TABLE_VIEW = "./FirstVisit/UPDATE_TABLE_VIEW";
export const UPDATE_TABLE_VIEW_SELECTED = "./FirstVisit/UPDATE_TABLE_VIEW_SELECTED";
export const FETCH_FILTERS_SUCCESS = "./FirstVisit/FETCH_FILTERS_SUCCESS";
export const UPDATE_FILTERS = "./FirstVisit/UPDATE_FILTERS";

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  updateDates: createAction(UPDATE_DATES),
  updateData: createAction(UPDATE_CHART),
  resetFilters: createAction(RESET_FILTER),
  updatePeriodDays: createAction(UPDATE_PERIOD_DAYS),
  updateCustomRange: createAction(UPDATE_CUSTOM_RANGE),
  updateTableView: createAction(UPDATE_TABLE_VIEW),
  updateFilters: createAction(UPDATE_FILTERS)
};

export default function* watchActiveMembers() {
  yield takeLatest(FETCH_CURRENT_USER, fetchCurrentUserData);
  yield takeLatest(UPDATE_CHART, updateData);
  yield takeLatest(RESET_FILTER, resetFilters);
  yield takeLatest(UPDATE_TABLE_VIEW, updateTableView);
}

export function* fetchCurrentUserData(data) {
  yield put({
    type: FETCH_CURRENT_USER_SUCCESS,
    payload: data.payload
  });
  yield put({ type: SET_LOADING, payload: true });
  let dates = yield getDatesHelper();
  yield setDates(...dates);
  try {
    let allSagas = [fetchChart(), fetchFilters()];
    yield all(allSagas);
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* getCommonApiParams() {
  const { organization_id, short_url } = yield select((state) => state.commonReducer.commonProps);
  return yield select((state) => {
    const {
      selectedRequestDates: { startDate, endDate },
      selectedFilters: { table_view, period_days, category }
    } = state.noVisitAfterFirstVisit;
    const categories = category.map(({ id }) => id).join(",");

    return {
      organization_id,
      short_url,
      startDate,
      endDate,
      table_view,
      period_days,
      categories: categories.length === 0 ? undefined : categories
    };
  });
}

function* updateTableView({ payload }) {
  yield put({ type: SET_UPDATES_LOADING, payload: true });
  yield put({ type: UPDATE_TABLE_VIEW_SELECTED, payload });
  try {
    yield fetchChart();
    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* fetchChart() {
  yield put({ type: SET_UPDATES_LOADING, payload: true });
  const { organization_id, short_url, startDate, endDate, table_view, period_days, categories } =
    yield getCommonApiParams();

  const params = {
    organization_id,
    short_url,
    end_date: endDate,
    start_date: startDate,
    table_view,
    period_days: period_days?.replace(" days", ""),
    categories
  };

  let url =
    queryParams.apiVersion + "pages/retention/clients_not_returning_after_first_visit_chart";
  try {
    let { data } = yield call(axios.get, url, { params });
    yield put({ type: FETCH_CHART_SUCCESS, payload: data.data });
    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (err) {
    console.error(err);
  }
}

export function* fetchFilters() {
  const { organization_id, short_url, startDate, endDate } = yield getCommonApiParams();

  const params = {
    organization_id,
    short_url,
    end_date: endDate,
    start_date: startDate
  };

  let url =
    queryParams.apiVersion +
    "pages/retention/clients_not_returning_after_first_visit_chart/filters";

  try {
    let { data } = yield call(axios.get, url, { params });
    yield put({ type: FETCH_FILTERS_SUCCESS, payload: data.filters.classTypes.options });
  } catch (err) {
    console.error(err);
  }
}

export function* setDates(startDate, endDate) {
  yield put({
    type: SET_DATES,
    payload: {
      startDate,
      endDate
    }
  });
}

function* updateData() {
  yield put({ type: SET_UPDATES_LOADING, payload: true });
  try {
    yield put({ type: SET_FILTERS_DIRTY, payload: false });
    yield fetchChart();
    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* resetFilters() {
  yield put({ type: SET_UPDATES_LOADING, payload: true });
  let dates = yield getDatesHelper();
  yield setDates(...dates);
  yield put({ type: RESET_FILTER_SELECTED });
  try {
    let allSagas = [fetchChart(), fetchFilters()];
    yield all(allSagas);
    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* getDatesHelper() {
  const endDate = yield select((state) => state.noVisitAfterFirstVisit.currentUser.calendarEndDate);
  const startDate = moment(endDate).startOf("month").subtract(11, "months").format(API_DATE_FORMAT);
  return [startDate, endDate];
}
